module.exports = ".fancybox-slide--video .fancybox-content {\n  width: 600px;\n  height: 600px;\n  max-width: 80%;\n  max-height: 80%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-page/home-page.component.scss
// module id = ./src/app/home-page/home-page.component.scss
// module chunks = main